import { User, UserFacadeService } from '@anecdotes/identity';
import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-user-details',
  templateUrl: './user-details.component.html',
  styleUrls: ['./user-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class UserDetailsComponent implements OnChanges {
  @Input() searchable = false;
  @Input() userId: string;

  user$: Observable<User>;

  constructor(private userFacadeService: UserFacadeService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if ('userId' in changes) {
      this.user$ = this.userId ? this.userFacadeService.getUser(this.userId) : undefined;
    }
  }

  getUserFullName(user:User): string {
    return `${user.first_name} ${user.last_name}`;
  }
}
